import { useRef } from "react";

export const useSmartRef = (value) => {
  const ref = useRef(value);
  ref.current = value;

  return ref;
};
